import { useMutation, useQuery, useQueryClient, UseQueryResult } from 'react-query';
import { AxiosInstance } from '../axios.config';
import { api } from '../constants';
import { IGetProductParams } from '../manageProduct';
import { IReturnProduct, ReturnCountsResponse } from './types';

const getReturnProducts = async (
  params: IGetProductParams,
): Promise<{ results: IReturnProduct[]; pageSize: number; count: number }> => {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value != null && value !== ''),
  );
  const response = await AxiosInstance.get(api.returnProduct.list, {
    params: filteredParams,
  });

  return response.data;
};

const useGetReturnProducts = (
  params: IGetProductParams,
): UseQueryResult<{
  results: IReturnProduct[];
  pageSize: number;
  count: number;
  page_count: number;
}> => {
  return useQuery({
    queryKey: ['returnProducts', params],
    queryFn: () => getReturnProducts(params),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    refetchOnMount: false,
  });
};

// const useGetReturnProducts = (
//   params: IGetProductParams,
// ): UseQueryResult<{
//   results: IReturnProduct[];
//   pageSize: number;
//   count: number;
//   page_count: number;
// }> => {
//   return useQuery({
//     queryKey: ['returnProducts', params.status, params.page, params.query],
//     queryFn: () => getReturnProducts(params),
//     keepPreviousData: true,
//     gcTime: 5 * 60 * 1000, // Cache data for 5 minutes (in milliseconds)
//     staleTime: 1 * 60 * 1000, // Data is fresh for 1 minute
//     retry: 2, // Retry failed requests up to 2 times
//     refetchOnWindowFocus: false, // Disable refetch on window focus
//   });
// };

const approveRejectReturn = (data: {
  id: string;
  has_approved: boolean;
  rejection_reason?: string | null;
}) => {
  const { id, ...payload } = data;
  return AxiosInstance.patch(api.returnProduct.approve_reject.replace(':id', id), payload);
};

const useApproveRejectReturn = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['approveRejectReturn'],
    mutationFn: approveRejectReturn,
    onSuccess: () => {
      queryClient.invalidateQueries('returnProducts');
    },
  });
};

const markOrderAsReceived = (orderId: string) => {
  return AxiosInstance.get(api.returnProduct.order_received, {
    params: { order_id: orderId },
  });
};

const useMarkOrderAsReceived = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['markOrderAsReceived'],
    mutationFn: markOrderAsReceived,
    onSuccess: () => {
      queryClient.invalidateQueries('returnProducts');
    },
  });
};
const useGetReturnCounts = (): UseQueryResult<ReturnCountsResponse> => {
  return useQuery({
    queryKey: ['returnOrderCounts'],
    queryFn: async () => {
      const { data } = await AxiosInstance.get<ReturnCountsResponse>(api.returnProduct.count);
      return data;
    },
    staleTime: 5 * 60 * 1000, // 5 min fresh
    cacheTime: 30 * 60 * 1000, // keep in cache for 30 min
    refetchOnWindowFocus: false,
  });
};
export { useGetReturnProducts, useApproveRejectReturn, useMarkOrderAsReceived, useGetReturnCounts };
